import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoneyBill, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { NumericFormat } from 'react-number-format';

const Subtotales = ({ cuenta, onClick, estadoPasarela, cierre, checkDomi }) => (
	<div className="contSubtotales">
		<div className='d-flex'>
			<div className="col-8 cont_text_Subtotales">
				<p>Subtotal</p>
				<p>Descuento</p>
				{checkDomi ? <p>Envío</p> : null}
				<p>Impuesto {"(Taxes)"}</p>
				<h4>Total</h4>
			</div>
			<div className="col-4 cont_val_Subtotales">
				<p><NumericFormat value={cuenta.subtotal} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
				<p><NumericFormat value={cuenta.descuento} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
				{checkDomi ? <p><NumericFormat value={cuenta.costoEnvio} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p> : null}
				<p><NumericFormat value={cuenta.valor_impuesto} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
				<h4><NumericFormat value={cuenta.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /></h4>
			</div>
		</div>
		<div className='d-flex'>
			<div className="col-12 cont_botones_pos">
				{cierre === 'cerrado' ?
					<div className="btn boton_estandar-subtotal">
						<span>Caja Cerrada</span>
					</div>
					: null}
				{cierre === 'abierto' ?
					<button
						onClick={onClick}
						className="btn boton_estandar-subtotal">
						{estadoPasarela ?
							<div>
								<FontAwesomeIcon icon={faArrowLeft} /> Seguir Comprando
							</div>
							:
							<div>
								Total Pagar
							</div>
						}
					</button>

					: null}
			</div>
		</div>
	</div>

)




export default Subtotales